const productsEscola = [
  {
    id: 47,
    pinPos: [330.7857546752137, 377.22062715692715, -787.5805087983524],
    scale: 1.3,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 32.21796662774922,
        y: 262.7978378671578,
        z: -491.385442643306,
      },
      target: {
        x: 32.76991207443634,
        y: 263.0405808276751,
        z: -492.1832095760631,
      },
      posMobile: {
        x: 32.21796662774922,
        y: 262.7978378671578,
        z: -491.385442643306,
      },
      targetMobile: {
        x: 32.76991207443634,
        y: 263.0405808276751,
        z: -492.1832095760631,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24500852574643,
        y: 230.68268724679493,
        z: 174.9695176413039,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 48,
    pinPos: [-158.44429759298703, 294.4780704724762, -706.0350863705239],
    scale: 1.3,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -155.03012657480812,
        y: 345.8226289509743,
        z: -331.0773456606138,
      },
      target: {
        x: -155.2008766203111,
        y: 345.7252912547883,
        z: -332.05784032906536,
      },
      posMobile: {
        x: -155.03012657480812,
        y: 345.8226289509743,
        z: -331.0773456606138,
      },
      targetMobile: {
        x: -155.2008766203111,
        y: 345.7252912547883,
        z: -332.05784032906536,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24500852574643,
        y: 230.68268724679493,
        z: 174.9695176413039,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 49,
    pinPos: [-69.13113179683086, 26.99788696567117, -332.7866801821893],
    scale: 1.2,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -517.3245397865057,
        y: 159.9949845744708,
        z: -242.1338759663725,
      },
      target: {
        x: -516.4460833606671,
        y: 159.67747557914376,
        z: -242.49095067254646,
      },
      posMobile: {
        x: -517.3245397865057,
        y: 159.9949845744708,
        z: -242.1338759663725,
      },
      targetMobile: {
        x: -516.4460833606671,
        y: 159.67747557914376,
        z: -242.49095067254646,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24500852574643,
        y: 230.68268724679493,
        z: 174.9695176413039,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },

  {
    id: 50,
    pinPos: [-292.1534474790856, 425.418208649301, -216.56019290851796],
    scale: 1,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -144.3789522405082,
        y: 177.40300289405548,
        z: 36.25948673319149,
      },
      target: {
        x: -144.89137321304185,
        y: 178.05277613601984,
        z: 35.698042630065636,
      },
      posMobile: {
        x: -144.3789522405082,
        y: 177.40300289405548,
        z: 36.25948673319149,
      },
      targetMobile: {
        x: -144.89137321304185,
        y: 178.05277613601984,
        z: 35.698042630065636,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24500852574643,
        y: 230.68268724679493,
        z: 174.9695176413039,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 51,
    pinPos: [409.59470745567415, 236.75646564911477, -644.6432773159007],
    scale: 1,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 217.06301377727044,
        y: 306.0549609833397,
        z: -471.809888332636,
      },
      target: {
        x: 217.65818769731533,
        y: 305.7999879377654,
        z: -472.57196231259394,
      },
      posMobile: {
        x: 217.06301377727044,
        y: 306.0549609833397,
        z: -471.809888332636,
      },
      targetMobile: {
        x: 217.65818769731533,
        y: 305.7999879377654,
        z: -472.57196231259394,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24500852574643,
        y: 230.68268724679493,
        z: 174.9695176413039,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 64,
    pinPos: [388.62508802770276, 428.2791976186935, -503.86995445856286],
    scale: 1,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 282.8462671400092,
        y: 228.8929437824261,
        z: -393.117555478612,
      },
      target: {
        x: 283.1266343159541,
        y: 229.69369242876581,
        z: -393.64689077125536,
      },
      posMobile: {
        x: 282.8462671400092,
        y: 228.8929437824261,
        z: -393.117555478612,
      },
      targetMobile: {
        x: 283.1266343159541,
        y: 229.69369242876581,
        z: -393.64689077125536,
      },
    },
    cameraOut: {
      pos: {
        x: 74.24500852574643,
        y: 230.68268724679493,
        z: 174.9695176413039,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
];

export default productsEscola;
